/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LobbyImageModel } from '../../models/lobby-image-model';

export interface LobbyImagePost$Params {
      body?: LobbyImageModel
}

export function lobbyImagePost(http: HttpClient, rootUrl: string, params?: LobbyImagePost$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, lobbyImagePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ACSStrictHttpResponse<string>;
    })
  );
}

lobbyImagePost.PATH = '/Lobby/Image';
